import { render, staticRenderFns } from "./goal.vue?vue&type=template&id=7ca37a3d&scoped=true&"
import script from "./goal.vue?vue&type=script&lang=js&"
export * from "./goal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca37a3d",
  null
  
)

export default component.exports